<template>
    <p>Over the span of this internship I designed, developed, and deployed a quiz platform. The quiz platform allows Funeral Innovation's (FI) admin to easily create quizzes using an intuitive web application interface. Admin can then deploy the quizzes to customers' Facebooks and websites. End users can then take the quizzes and the results are saved to a database and sent to customers.</p>
    <p>In addition to the quiz platform, I initiated and built a configurable webcrawler which helped solve an issue of repeated code across configurations.</p>
    <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
</template>

<script>
    import LogoScroller from '@/components/LogoScroller'

    export default {
        name: "SoftwareEngineerTimeline",
        components: {
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'mysql',
                    'php',
                    'cakephp',
                    'jquery',
                    'js',
                    'html5',
                    'css3',
                ]
            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style>

</style>